;(function () {

    if (!points_setting.image) return

    let shopDomain_ld
    let customerId_ld = null
    if (window.__st && window.__st.cid !== undefined) {
        customerId_ld = window.__st.cid
    }
    shopDomain_ld = window.Shopify && window.Shopify.shop
    let ldLocation = window.location.host

    window.__LD = {}

    window.__LD.LAUNCHER_STATE = 1

    let ld_fontLink_rs = document.createElement('link')
    ld_fontLink_rs.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@100;300;400;500;700&display=swap'
    ld_fontLink_rs.rel = 'stylesheet'
    document.body.appendChild(ld_fontLink_rs)

    //adding style
    let LdstyleRewards = document.createElement('style')
    LdstyleRewards.textContent = `
    @keyframes superFadeScaleIn {
    0% {
        opacity: 0;
        transform: scale(.8);
        visibility: hidden;
    }
    100% {
        opacity: 1;
        transform: scale(1);
        visibility: visible;
    }
    }
    @keyframes superFadeSlideUp {
    0% {
        opacity: 0;
        transform: translate3d(0,10px,0);
    }
    100% {
        opacity: 1;
        transform: translateZ(0);
    }
    }
    @keyframes superFadeSlideDown {
    0% {
        opacity: 1;
        transform: translateZ(0);
    }
    100% {
        opacity: 0;
        transform: translate3d(0,10px,0);
    }
    }
    `

    const getLdIconSVGString = (widgetIcon, font) => {
        const color = font || '#6A71FF'

        switch (widgetIcon) {
            case 'fa-gift':
                return `<svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
        >
            <path
            fill="${color}"
            fill-rule="nonzero"
            d="M13 16v14H7a4 4 0 0 1-4-4V16h10zm4 0h10v10a4 4 0 0 1-4 4h-6V16zm-4-8v6H2.5A1.5 1.5 0 0 1 1 12.5v-3A1.5 1.5 0 0 1 2.5 8H13zm4 0h10.5A1.5 1.5 0 0 1 29 9.5v3a1.5 1.5 0 0 1-1.5 1.5H17V8zm-7-8h.004a3.541 3.541 0 0 1 3.494 2.964L14 6h-4a3 3 0 1 1 0-6zm10 0a3 3 0 0 1 0 6h-4l.502-3.036A3.541 3.541 0 0 1 19.996 0H20z"
            />
        </svg>`

            case 'fa-shopping-bag':
                return `<svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
        >
            <path
            fill="${color}"
            fill-rule="evenodd"
            d="M8 8V7a5 5 0 0 1 10 0v1h3.446a2 2 0 0 1 1.991 1.818l.42 4.597a1 1 0 0 1-1.992.182L21.445 10H18v2a1 1 0 0 1-2 0v-2h-6v2a1 1 0 0 1-2 0v-2H4.554a165320.029 165320.029 0 0 0-1.457 16H15a1 1 0 0 1 0 2H2.548a1.5 1.5 0 0 1-1.5-1.5c.008-.15.008-.15.027-.353l.071-.78.283-3.113L2.563 9.818A2 2 0 0 1 4.554 8H8zm2 0h6V7a3 3 0 0 0-6 0v1zm18.002 9.76a3.854 3.854 0 0 1-.13 5.535l-4.643 4.616a1 1 0 0 1-1.41 0l-4.646-4.613c-.041-.044-.085-.086-.127-.13a3.854 3.854 0 0 1 0-5.408c1.477-1.494 4.527-1.099 5.478 1.202.96-2.298 4-2.696 5.478-1.202z"
            />
        </svg>`

            case 'fa-tags':
                return `<svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
        >
            <path
            fill="${color}"
            fill-rule="nonzero"
            d="M3.071 14.47a.5.5 0 0 0 .147.354l12.288 12.289L26.82 15.799 14.53 3.51a.5.5 0 0 0-.353-.146H3.07v11.107zm-2 0V3.365a2 2 0 0 1 2-2h11.107a2.5 2.5 0 0 1 1.767.732l12.289 12.289a2 2 0 0 1 0 2.828L16.92 28.527a2 2 0 0 1-2.828 0L1.803 16.238a2.5 2.5 0 0 1-.732-1.767zm7.364-5.742a2 2 0 1 0-2.828-2.829 2 2 0 0 0 2.828 2.829zm11.592 10.844a2.7 2.7 0 0 0 .77-1.895C20.797 16.2 19.616 15 18.16 15c-.728 0-2.15.273-2.637 2.128C15.11 15.245 13.614 15 12.887 15c-1.456 0-2.637 1.2-2.637 2.677 0 .739.295 1.403.77 1.895l3.914 3.974a.827.827 0 0 0 1.179 0l3.914-3.974z"
            />
        </svg>`

            case 'fa-crown':
                return `<svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
        >
            <path
            fill="${color}"
            fill-rule="nonzero"
            d="M1.962 11.31l6.53 2.382c.098.036.21.005.273-.077l5.666-7.338a.724.724 0 0 1 1.15.014l5.346 7.32a.241.241 0 0 0 .274.084l6.846-2.389c.517-.18 1.04.252.94.777l-2.138 11.35a.707.707 0 0 1-.7.567H3.851a.707.707 0 0 1-.7-.567l-2.14-11.35c-.1-.53.432-.962.95-.773"
            />
        </svg>`

            case 'fa-star':
                return `<svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
        >
            <path
            fill="${color}"
            fill-rule="nonzero"
            d="M15 23.65l-7.07 3.597A1 1 0 0 1 6.489 26.2l1.235-7.836-5.605-5.613a1 1 0 0 1 .55-1.694l7.834-1.246 3.606-7.066a1 1 0 0 1 1.782 0l3.606 7.066 7.834 1.246a1 1 0 0 1 .55 1.694l-5.605 5.613L23.51 26.2a1 1 0 0 1-1.44 1.047L15 23.65z"
            />
        </svg>`

            default:
                return `<svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
        >
            <path
            fill="${color}"
            fill-rule="nonzero"
            d="M13 16v14H7a4 4 0 0 1-4-4V16h10zm4 0h10v10a4 4 0 0 1-4 4h-6V16zm-4-8v6H2.5A1.5 1.5 0 0 1 1 12.5v-3A1.5 1.5 0 0 1 2.5 8H13zm4 0h10.5A1.5 1.5 0 0 1 29 9.5v3a1.5 1.5 0 0 1-1.5 1.5H17V8zm-7-8h.004a3.541 3.541 0 0 1 3.494 2.964L14 6h-4a3 3 0 1 1 0-6zm10 0a3 3 0 0 1 0 6h-4l.502-3.036A3.541 3.541 0 0 1 19.996 0H20z"
            />
        </svg>`
        }
    }

    var LdLauncher = document.createElement('div')
    LdLauncher.setAttribute('id', 'Ld-launcher')

    LdLauncher.style.cssText = `
    height:60px;
    min-width:60px;
    position:fixed;
    bottom:200px;
    right:0;
    z-index:2147483646 !important;
    border-radius:50px;
    margin: 0 20px 20px 0;
    font-size:20px;
    display:flex;
    justify-content:center;
    align-items:center;
    cursor:pointer;
        color:#fff;
    box-shadow: 0 0 80px 20px rgb(0 0 0 / 12%);
    -webkit-animation: superFadeScaleIn .2s ease-in-out!important;
        animation: superFadeScaleIn .2s ease-in-out!important;
        -webkit-animation-delay: .15s!important;
        animation-delay: .15s!important;
        -webkit-animation-fill-mode: forwards!important;
        animation-fill-mode: forwards!important;
        transition: all .2s ease-in-out!important;

    `

    let LdLauncherIcon = document.createElement('img')

    LdLauncherIcon.style.cssText += `
    width:60px;
    height:60px
    `
    LdLauncherIcon.src = points_setting.image
    LdLauncher.appendChild(LdLauncherIcon)

    document.body.appendChild(LdLauncher)

    __LD.startBtn = LdLauncher

    function LdSvgToImageURI(svgString) {
        try {
            // replace all the newlines and tabs
            svgString = svgString.replace(/\n/g, '').replace(/\t/g, '')
            return `data:image/svg+xml;utf8,${encodeURIComponent(svgString)}`
        } catch (error) {
            return ''
        }
    }

    function setLdLauncherIcon(launcherIconData) {
        const iconSVGString = getLdIconSVGString(launcherIconData?.widgetIcon, launcherIconData?.font)
        LdLauncherIcon.src = LdSvgToImageURI(iconSVGString)
    }

    // setLdLauncherIcon({
    //     widgetIcon: "'fa-gift'",
    //     font: '#fff',
    // })

    LdLauncher.addEventListener('click', () => {
        // console.log('clicked')
        // remove location hash
        if (LdIframeWrapperDiv.style.display === 'none') {
            LdIframeWrapperDiv.style.display = 'initial'
            LdLauncherIcon.style.display = 'initial'
            //LdLauncherIcon.src =
            //    "data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3E%3Cpath fill='%23FFF' fill-rule='nonzero' d='M11.06 10l3.713 3.712a.75.75 0 0 1-1.06 1.061L10 11.061l-3.712 3.712a.75.75 0 0 1-1.061-1.06L8.939 10 5.227 6.288a.75.75 0 1 1 1.06-1.061L10 8.939l3.712-3.712a.75.75 0 0 1 1.061 1.06L11.061 10z'/%3E%3C/svg%3E"
            
        } else {
            LdIframeWrapperDiv.style.display = 'none'
            // setLdLauncherIcon({
            //     widgetIcon: "'fa-gift'",
            //     font: '#fff',
            // })
        }
        LdLauncherIcon.src = points_setting.image
    })

    let LdIframeWrapperDiv = document.createElement('div')
    LdIframeWrapperDiv.setAttribute('id', 'rewards-widget')
    LdIframeWrapperDiv.style.cssText = `
    height: calc(100% - 120px);
    max-height: 600px;
    width:360px;
    position:fixed;
    bottom:0;
    right:70px;
    margin: 0px 25px 107px 0px;
    z-index : 2147483647 !important;
    border-radius:10px;
    overflow:hidden;
    box-shadow: 0 0 80px 0 rgb(0 0 0 / 12%);
    display:none;
    -webkit-animation: superFadeSlideUp .2s ease-in!important;
    animation: superFadeSlideUp .2s ease-in!important;
    background-color: #ffffff;
    `

    document.body.appendChild(LdIframeWrapperDiv)

    let LdIframe = document.createElement('iframe')
    LdIframe.name = 'ld-rewards-widget-iframe'

    LdIframe.src = `https://shopify.legenddoll.com/customer?shopDomain=${shopDomain_ld}&customerId=${customerId_ld}&parentLocation=${ldLocation}`
    LdIframe.allow = 'clipboard-write; clipboard-read;'
    LdIframeWrapperDiv.appendChild(LdIframe)

    LdIframe.style.cssText = 'width:100%; height: 100%; border:none;'

    LdIframeWrapperDiv.appendChild(LdIframe)

    const LdMediaQuery = window.matchMedia('(max-width: 550px)')

    function LdHandleMobileChange(e, postition) {
        // Check if the media query is true
        // console.log('LdHandleMobileChange', e , postition)
        if (e.matches) {
            LdIframeWrapperDiv.style.cssText += `
        width: 100%;
        height: 100%;
        max-height: 100vh;
        max-width: 100vw;
        margin: 0;
        inset:0; 
        border-radius: 0;
        `
        } else {
            LdIframeWrapperDiv.style.cssText += `
    height: calc(100% - 120px);
    max-height: 600px;
    width:360px;
    inset:unset;
    ${postition}
    bottom:0;
    border-radius:10px;
    `
        }
    }

    LdMediaQuery.addListener(LdHandleMobileChange)

    LdHandleMobileChange(LdMediaQuery, 'right:0;')

    // postmessage Event from react-widget
    function LdGetData(e) {
        if (typeof e.data == 'object' && e.data?.display) {
            LdIframeWrapperDiv.style.display = e.data.display

            if (e.data.display === 'none') {
                // setLdLauncherIcon({
                //     widgetIcon: "'fa-gift'",
                //     font: '#fff',
                // })
            } else {
                LdIframeWrapperDiv.style.display = 'initial'
                LdLauncherIcon.style.display = 'initial'
                //LdLauncherIcon.src =
                //    "data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3E%3Cpath fill='%23FFF' fill-rule='nonzero' d='M11.06 10l3.713 3.712a.75.75 0 0 1-1.06 1.061L10 11.061l-3.712 3.712a.75.75 0 0 1-1.061-1.06L8.939 10 5.227 6.288a.75.75 0 1 1 1.06-1.061L10 8.939l3.712-3.712a.75.75 0 0 1 1.061 1.06L11.061 10z'/%3E%3C/svg%3E"
                LdLauncher.style.padding = '0'
            }
            LdLauncherIcon.src = points_setting.image
        }
    }
    window.addEventListener('message', LdGetData, false)

    /* // 确保文档加载完毕
    document.addEventListener('DOMContentLoaded', function () {
    // 获取购物车弹窗页面的顶部容器
    var cartContainer = document.querySelector('.cart__ctas');
    
    // 检查容器是否存在
    if (cartContainer) {
        // 创建一个新的div元素，包含你的扩展内容
        var extensionContent = document.createElement('div');
        extensionContent.innerHTML = '<a href="/products">查看全部产品</a>';
    
        // 将新创建的元素添加到购物车页面顶部容器中
        cartContainer.insertBefore(extensionContent, cartContainer.firstChild);
    }
    }); */
})(window)
